import React from 'react';
import { EntityHeaderDto } from '@decisions/server/DecisionsFramework/ServiceLayer/Services/EntityDetails';
import { EntityHeaderView } from 'components/EntityDetails/EntityHeaderView';
import { getDetailsItemClasses } from '../panelSettings';
import { detailsDependenciesClass } from './Dependencies';

export function DependenciesList({ dependencies, registrationClick }: any) {
  return (
    <>
      {(dependencies as EntityHeaderDto[]).map((dependency: EntityHeaderDto, index: number) => (
        <EntityHeaderView
          key={index}
          entity={dependency}
          onViewClick={registrationClick}
          className={getDetailsItemClasses(detailsDependenciesClass, false)}
        />
      ))}
    </>
  );
}
